import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableCell, TableContainer, TableRow, TextareaAutosize, Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { useParams } from 'react-router-dom';
import { fetchStitchingReg, UpdateStitchingEntry } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchReg } from '../Selectors/StitchSelector/StitchingSelectors';


const StitchingUpdate = () => {

    const { Id } = useParams();
    const [formData, setFormData] = useState({
        stId: parseInt(Id),
        ctId: '',
        dt: '',
        stMemo: '',
        ctMemo: '',
        sono: '0',
        soId: '',
        empType: '',
        empNm: '',
        empId: '',
        itemId: '',
        itemNm: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        instructions: '',
        totqty: '',
        userId: '1',
    });

    const [errors, setErrors] = useState({});
    const [itemData, setItemData] = useState([]);

    const dispatch = useDispatch();

    const stitchlist = useSelector(selectStitchReg);
    useEffect(() => {
        dispatch(fetchStitchingReg(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (stitchlist.data.length > 0) {
            const value = stitchlist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: value.dt,
                stMemo: value.stMemo,
                ctMemo: value.ctMemo,
                empNm: value.empNm,
                empId: value.empId,
                itemId: value.itemId,
                itemNm: value.itemNm,
                soId: value.soId,
                sono: value.sono,
                mcloth: value.mcloth,
                m1cloth: value.m1cloth,
                m2cloth: value.m2cloth,
                m3cloth: value.m3cloth,
                mclothNm: value.mclothNm,
                m1clothNm: value.m1clothNm,
                m2clothNm: value.m2clothNm,
                m3clothNm: value.m3clothNm,
                instructions: value.instruction,
                empType: value.empType,
                ctId: value.ctId
            }))
        }
        if (stitchlist.Info.length > 0) {
            const data = stitchlist.Info;
            const duplicate_data = data.map((item) => ({
                ID: item.ID,
                size: item.size,
                ctqty: item.ctqty,
                issqty: item.issqty
            }));
            setItemData(duplicate_data);
        }
    }, [stitchlist]);


    useEffect(() => {
        if (itemData.length > 0) {
            const values = itemData.map(item => item.issqty);
            const sum_val = values.length > 0 ? values.reduce((acc, qty) => acc + parseInt(qty, 10), 0) : null;

            setFormData(prev => ({
                ...prev,
                totqty: sum_val
            }));
        }
    }, [itemData]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    // const handleCuttingInfoChange = (index, field, value) => {
    //     const soId = formData.soId; // Get soId from formData
    //     const soQty = cuttingInfo[index]?.soqty; // Get soqty for the specific item

    //     // Allow empty input or only numbers
    //     if (value === '' || !isNaN(value)) {
    //         if (soId !== '0' && parseInt(value) > soQty) {
    //             alert(`Quantity cannot exceed SO qty of ${soQty}.`);
    //             return; // Prevent state update
    //         }

    //         setCuttingInfo(prevCuttingInfo => {
    //             const updatedCuttingInfo = [...prevCuttingInfo];
    //             updatedCuttingInfo[index] = {
    //                 ...updatedCuttingInfo[index],
    //                 [field]: value,
    //             };
    //             return updatedCuttingInfo;
    //         });
    //     }


    // };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleChange = (index, value) => {
        const newIssQty = parseFloat(value) || 0;
        setItemData(prevData => {
            // Check if ctqty is less than the new issqty
            if (newIssQty > prevData[index].ctqty) {
                alert(`Issued quantity cannot be greater than ${prevData[index].ctqty}.`);
                return prevData; // Do not update state if the condition fails
            }

            // Update the specific item's issqty in the itemData array
            return prevData.map((item, i) =>
                i === index ? { ...item, issqty: newIssQty } : item
            );
        });

    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertOneObject(formData, itemData) {
        const data = {
            dt: formData.dt,
            stId: formData.stId,
            ctId: formData.ctId,
            instruction: formData.instructions,
            totqty: formData.totqty,
            itemData: itemData,
            userId: formData.userId
        }
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObj = convertOneObject(formData, itemData);
        // console.log(finalObj);
        dispatch(UpdateStitchingEntry(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cutting Updated");
                alert("Records Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '1% 1%' }}>
                <h2 style={{ textAlign: 'center' }}>{formData.empType === '1' ? 'Stitching Entry(In-House) Edit' : 'Contractor Stitching Edit'}</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='stMemo'>Stitching Memo:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='stMemo'

                                                >
                                                    {formData.stMemo || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='ctMemo'>Cutting Memo No.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='ctMemo'

                                                >
                                                    {formData.ctMemo || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='empNm'>Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='empNm'

                                                >
                                                    {formData.empNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.soId !== '0' &&
                                    <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>Sale Order No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='sono'

                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }


                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='itemNm'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='itemNm'

                                                >
                                                    {formData.itemNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mclothNm'>Main Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mclothNm'

                                                >
                                                    {formData.mclothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {formData.m1cloth !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1clothNm'>Matching-1 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1clothNm'

                                                        >
                                                            {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                    </>
                                }

                                {formData.m2cloth !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2clothNm'>Matching-2 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2clothNm'

                                                        >
                                                            {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </>
                                }

                                {formData.m3cloth !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3clothNm'>Matching-3 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3clothNm'

                                                        >
                                                            {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                    </>
                                }


                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totqty'>Total Qty:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='totqty'

                                                >
                                                    {formData.totqty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {itemData.length > 0 &&
                                    (<Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    {itemData.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                    ))}

                                                </TableRow>

                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty.</TableCell>
                                                    {itemData.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.ctqty}</TableCell>
                                                    ))}

                                                </TableRow>

                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Issue Qty.</TableCell>
                                                    {itemData.map((item, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <input
                                                                type="text"
                                                                name='issqty'
                                                                value={item.issqty}
                                                                onChange={(e) => handleChange(index, e.target.value)}
                                                                style={{ width: '40px', padding: '1px' }}
                                                            />
                                                        </TableCell>

                                                    ))}

                                                </TableRow>

                                            </Table>
                                        </TableContainer>
                                    </Grid>)
                                }

                                {[
                                    { label: 'Stitching Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid >
            </div >
        </>
    );
}

export default StitchingUpdate;
